import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

import {
  userRole_candidate,
  userRole_siteAdmin,
  userRole_proctor
} from './../../Common/appConstant';
import { AppMessage } from './../../Common/appMessage';
import { AppGlobals } from './../../Common/Services/app.global';
import { SharedService } from './../../Common/Services/shared.service';
import { Utility } from './../../Common/Services/utility';

@Component({
  selector: 'app-authenticate-user',
  templateUrl: './authenticate-user.component.html',
  styleUrls: ['./authenticate-user.component.css']
})
export class AuthenticateUserComponent implements OnInit {

  constructor(public _router: Router, private _activatedRoute: ActivatedRoute, private _utility: Utility, private _appGlobals: AppGlobals
    , private _sharedService: SharedService, public _appMessage: AppMessage) {
  }

  ngOnInit() {
    // subscribe to get settings from settings.json

    // reset admin user settings
    this._utility.adminUnbecomeCandidate();

    this._sharedService.getSettingsJSON().subscribe(
      settingsData => {
        // subscribe to router event
        let apiURL = settingsData.apiURL;
        if (!apiURL) {
          this._router.navigate(['**']);
          return;
        }
        this._appGlobals.baseURL.next(apiURL);
        this.setSettingsData(settingsData);
      });
  }

  setSettingsData(settingsData: any): void {
    let cRoute = this._router.url;
    //    set blank log out URL in logoutURL variable  if request is coming from internal user because we don't have any logout url for internal user
    if (cRoute.toLowerCase().indexOf("authenticateinternaluser") > -1) {
      this._appGlobals.logoutURL.next("");
    }

    // GET PARAMS defined by "?"
    this._activatedRoute.queryParams.subscribe((params: Params) => {
      // IF logouturl comes then get logout url from BrowserURL itself
      if (params.logoutURLExternal) {
        let pathname = location.pathname;
        pathname += 'services/externaluser/login'; // create complete URL for external logout
        let url = `${params.logoutURLExternal}?redirect=${location.origin}${pathname}`; // we have added redirect string so it is like "https://sso.dev1.redhat.com/auth/realms/redhat-external/logout?redirect=https://individualexamscheduler-individualexamscheduler.ext.paas.dev.redhat.com/individualexamscheduler/services/externaluser/login"
        this._appGlobals.logoutURL.next(url); // set External User log out URL in logoutURL variable
      }

      if (params.rhId) {
        this._appGlobals.userAttemptingToLogin.next(params.rhId);
      }
    });

    // GET PARAMS
    this._activatedRoute.params.subscribe((params: Params) => {
      let lsToken = this._utility.getAccessTokenInLS();
      let paramEId = params['eid'];
      if (paramEId && paramEId.toUpperCase() != "S0001") {
        this._appGlobals.isInvalidToken = true; // set this value true because if error code comes in URL then we have to display message on access denied page.
        this._utility.logoutUser(false, paramEId);
        return;
      }
      let paramToken = params['id'];
      let finalToken = lsToken != null ? lsToken : null;
      if (lsToken == null && paramToken == null) {
        this._utility.logoutUser(false);
      }
      else {
        if (paramToken) {
          finalToken = paramToken;
        }
        this._appGlobals.accessToken.next(finalToken);
        this.setProfile();
      }
    });
  }

  // set user profile data
  private setProfile() {
    this._utility.clearList();
    this._utility.addLoaderCount();
    this._sharedService.getUserProfile()
      .subscribe(
        (data: any) => {
          this._utility.onSuccessCallback(data, null, () => {
            let resultData = data.response;

            // If Role is undefined or Null then logout application
            if (!resultData.userRole) {
              this._utility.logoutUser();
              return;
            }

            let role = resultData.userRole.toUpperCase(); // GET Role

            this._appGlobals.downloadArtifactsUrl = resultData.downloadArtifactsUrl;
            this._appGlobals.proctorAccessToken = resultData.proctorAccessToken;

            this._appGlobals.isInternalUser = (role == userRole_candidate || role == userRole_siteAdmin) ? false : true; // set Internal user true or false

            // user is logged in successfully, so set all basic data (like userInfo, leftMenusList_CUser, etc.)
            let finalToken = this._appGlobals.accessToken.getValue();
            this._utility.setAccessTokenInLS(finalToken);
            this._appGlobals.isUserLoggedIn.next(true);
            this._appGlobals.userInfo.next(resultData);

            this._appGlobals.acType.next(resultData.userRole); // set account Role in account Type

            let menusListObj = this._utility.leftMenusList[(role == userRole_proctor && resultData.isProctorLead) ? resultData.userRole.toLowerCase() + 'lead' : resultData.userRole.toLowerCase()]; // Based on Role Get Side menus from Menu.ts file
            this._appGlobals.leftMenusList_CUser.next(menusListObj);

            // call function to set master page
            this._utility.setReadyForMasterStatus(true);

            // load user permissions
            this.loadUserPermissions();

            //Finally  navigate user to landing page based on its role
            if (menusListObj && menusListObj.landingUrl) {
              this._router.navigate([menusListObj.landingUrl]);
            }
          });
        },
        error => {
          this._utility.onErrorCallback(error);
        });
  }

  private loadUserPermissions() {
    this._sharedService.getUserPermissions()
      .subscribe(
        (data) => {
          const permissions = new Set(
            data.map(({permission}) => permission)
          );
          this._appGlobals.userPermissions.next(permissions);
        },
        error => {
          console.error('Failed to load user permissions:', error);
        });
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/authenticate-user/authenticate-user.component.ts